import React, { Component }   from 'react';
import { connect }              from 'react-redux';
import moment                   from 'moment';
import ReactTooltip             from 'react-tooltip';
import { Scrollbars }           from 'react-custom-scrollbars';
import FlashCarregando          from '../../../container/FlashCarregando';
import { GetDuelosFinalizados } from '../../../actions/batalhaAction';
import { SetError }             from '../../../actions/authenticActions';
import img_batalha_fechada      from "../../../img/batalha/aviso_nao_concluiu_batalha.png";

class batalha_concluidos extends Component {

    constructor(props){
       
        super(props);
        this.state = { 
                       duelosAbertos      : [],
                       status             : "",
                       load               : false

                    };

     //   this.dueloPerfilUser = this.dueloPerfilUser.bind(this);            
               
    }

    componentWillMount() {
       
        this.props.GetDuelosFinalizados(this.props.session.id)
        .then((response) => {this.setState({load:true});}) 
        .catch((error) => {
            this.props.SetError(500);
        });     
    }

    renderBatalhaConcluido(){

        const duelos = this.props.dueloFinalizado;
        
        if (duelos.length) {

            return  duelos.map((elem,i) =>{
                // battle-versus-player-avatar-active
                const pontosDesafiante = (elem.desafiante.pontos > elem.desafiado.pontos? "battle-versus-player-avatar-active":"");
                const pontosDesafiado = (elem.desafiado.pontos > elem.desafiante.pontos? "battle-versus-player-avatar-active":"");
             return  <div className="battle-versus battle-versus-text" key={i}>
                            <div className="battle-versus-match">
                                <div className="battle-versus-match-player">
                                    <div className="battle-versus-player-name">{this.props.session.id == elem.desafiante.use_id? "VOCÊ":elem.desafiante.use_nome}</div>
                                    <div className={`battle-versus-player-avatar battle-versus-pontuacao ${pontosDesafiante}`}>
                                        <div className="battle-versus-player-avatar-placeholder">{elem.desafiante.pontos}</div>
                                    </div>
                                </div>
                                <div className="battle-versus-match-x">&times;</div>
                                <div className="battle-versus-match-player">
                                    <div className="battle-versus-player-name">{this.props.session.id == elem.desafiado.use_id? "VOCÊ":elem.desafiado.use_nome}</div>
                                    <div className={`battle-versus-player-avatar battle-versus-pontuacao ${pontosDesafiado}`}>
                                        <div className="battle-versus-player-avatar-placeholder">{elem.desafiado.pontos}</div>
                                    </div>
                                </div>
                            </div>
                        </div>;
            }); 

        }else{

            return <img className="img-responsive img-batalha-default" src={img_batalha_fechada}  alt="Foto"/>;
        }  
     }



    render() {
        return (
            <div className="battle-card-match">
                <div className="battle-card-match-title">
                    <div className="battle-card-match-title-text">Concluidos</div>
                    <div className="battle-box-title-decoration"></div>
                </div>
                <div className="battle-card-match-body">
                    <div className="battle-versus-list">
                     {this.state.load ? this.renderBatalhaConcluido(): <FlashCarregando/>}     
                    </div>
                    <div className="battle-card-match-body-decoration"></div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state){

    return {

      session         : state.auth.session,
      dueloFinalizado : state.batalhaReducer.allDueloFinalizada

    };
}

export default connect(mapStateToProps,{ GetDuelosFinalizados, SetError})(batalha_concluidos);



// WEBPACK FOOTER //
// ./src/components/aluno/batalha/batalha_concluidos.js